const PlayerCollection = () => {
  let _bunchOfPlayers = {};

  return {
    add(player) {
      if (this.exists(player.id)) {
        player.send('message', 'Already connected!');
        player.closeConnection();
        return;
      }

      _bunchOfPlayers[player.id] = player;
    },
    get(id) {
      return _bunchOfPlayers[id];
    },
    remove(id) {
      delete _bunchOfPlayers[id];
    },
    send(action, data) {
      this.iterate((player) => {
        player.send(action, data);
      });
    },
    exists(id) {
      return id in _bunchOfPlayers;
    },
    iterate(callback) {
      for (let [key, player] of Object.entries(_bunchOfPlayers)) {
        const result = callback(player, key);
        if (result !== undefined) {
          return result;
        }
      }
    },
  };
};

export default PlayerCollection;
